export default "__VITE_ASSET__badb0e3a__"